import React from "react";
import { Tabs, Form } from "antd";
import PropTypes from "prop-types";
import { AddUser } from '../../style';
import { BasicFormWrapper } from '../../../styled';
import CustomHtmlParser from '../../Email/CustomHtmlParser'
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'
import CallButton from '../GlobalComponents/CallButton'
import CopyButton from '../GlobalComponents/CopyButton'

const LeadTabPage = ({ displayData, setNaCTrigger }) => {
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="1">
                                    <TabPane tab="Basic Info" key="1">
                                        <Form.Item label="Primary Email" name="primaryEmail" className="custom-form-item">
                                            <span className="call-Optionholder">{(displayData?.primary_email && displayData?.primary_email !== "") ? <><span>{displayData?.primary_email}</span> <CopyButton apiKey={displayData?.primary_email} type="Email" /> </> : ""}</span>
                                        </Form.Item>
                                        <Form.Item label="Seniority Level" name="seniorityLevel" className="custom-form-item">
                                            <span className="">{displayData?.seniority_level}</span>
                                        </Form.Item>
                                        <Form.Item label="Secondary Email" name="secondaryEmail" className="custom-form-item">
                                            <span className="call-Optionholder">{(displayData?.secondary_email && displayData?.secondary_email !== "") ? <><span>{displayData?.secondary_email}</span> <CopyButton apiKey={displayData?.secondary_email} type="Email" /> </> : ""}</span>
                                        </Form.Item>
                                        <Form.Item label="Phone" name="phone" className="custom-form-item">
                                            <span className="call-Optionholder">{(displayData?.phone === "0" || displayData?.phone === 0) ? "" : <><span>{displayData?.phone}</span> <CallButton number={displayData?.phone} EntityData={{ type: "Lead", data: displayData, for: "Lead" }} setNaCTrigger={setNaCTrigger} /> </>} </span>
                                        </Form.Item>
                                        <Form.Item label="Fax" name="fax" className="custom-form-item">
                                            <span className="">{displayData?.fax}</span>
                                        </Form.Item>
                                        <Form.Item label="Mobile" name="mobile" className="custom-form-item">
                                            <span className="call-Optionholder">{(displayData?.mobile === "0" || displayData?.mobile === 0) ? "" : <><span>{displayData?.mobile}</span><CallButton number={displayData?.mobile} EntityData={{ type: "Lead", data: displayData, for: "Lead" }} setNaCTrigger={setNaCTrigger} /></>}</span>
                                        </Form.Item>
                                        <Form.Item label="Linkedin Url" name="linkedinUrl" className="custom-form-item">
                                            <span className="call-Optionholder">
                                                {displayData?.linkedin_url && displayData?.linkedin_url !== "" ? (
                                                    <>
                                                        <a
                                                            href={displayData?.linkedin_url.startsWith("http")
                                                                ? displayData?.linkedin_url
                                                                : `https://${displayData?.linkedin_url}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#407fe9", textDecoration: "none", marginRight: 8 }}
                                                        >
                                                            {displayData?.linkedin_url}
                                                        </a>
                                                        <CopyButton apiKey={displayData?.linkedin_url} type="URL" />
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </span>
                                        </Form.Item>
                                        <Form.Item label="Lead Description" name="description" className="custom-form-item">
                                            <CustomHtmlParser html={displayData?.description} key={1} page="TextBoxs" />
                                        </Form.Item>
                                        <Form.Item label="Account Description" name="description" className="custom-form-item">
                                            <CustomHtmlParser html={displayData?.account_description} key={2} page="TextBoxs" />
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Lead Info" key="2">
                                        <Form.Item label="Lead Source" name="leadSource" className="custom-form-item">
                                            {displayData?.lead_source_name}
                                        </Form.Item>
                                        <Form.Item label="Lead Status" name="leadStatus" className="custom-form-item">
                                            {displayData?.leads_status_name}
                                        </Form.Item>
                                        <Form.Item label="Email Opt Out?" className="custom-form-item">
                                            {displayData.email_opt_out === 1 || displayData.email_opt_out === true ? "Yes" : "No"}
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Address Info" key="3">
                                        <Form.Item label="Country" name="country" id="country" className="custom-form-item">
                                            {displayData?.country}
                                        </Form.Item>
                                        <Form.Item label="State" className="custom-form-item">
                                            {displayData?.state}
                                        </Form.Item>
                                        <Form.Item label="City" className="custom-form-item">
                                            {displayData?.city}
                                        </Form.Item>
                                        <Form.Item label="Street name and No" name="street" className="custom-form-item">
                                            {displayData?.street}
                                        </Form.Item>
                                        <Form.Item label="Zip Code" name="postcode" className="custom-form-item">
                                            {(displayData?.postcode === "0" || displayData.postcode === 0) ? "" : (displayData?.postcode)}
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Other Info" key="4">
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayData?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} />
                                                : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayData?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div>
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
}
export default React.memo(LeadTabPage)
